<template>
  <div id="app">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css" />
    <div id="nav">
      <div class="container">
        <div class="logo-wrapper animated fadeIn delay-1s">
          <router-link to="/">
            <plazaLogo class="svg-plaza-logo" />
          </router-link>
        </div>
        <div class="back-to-website">
          <img src="@/assets/frasers.jpg" class="animated fadeInDown" alt="">
          <br>
          <a href="https://www.frasersproperty.com.au/vic/burwood-brickworks" target="_blank">Exit to Burwood Brickworks</a>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>

    <main>
      <transition :name="transitionName">
        <router-view/>
      </transition>
    </main>

    <div class="container">
      <p class="disclaimer">
        DISCLAIMER: While every care is taken to ensure the contents of this is correct, any information is to be used as a guide only. All images (including artists impressions) and plans are indicative only. Prospective purchasers should rely on their own enquiries, legal advice and the contract of sale. This was completed prior to the completion of the design and construction of the project, therefore design, dimensions, fittings and specifications are subject to change. The developer reserves the right to amend the finish and selections that constitute the external fabric of the development due to unforeseen building constraints and product availability. Distances are approximate only. All areas are provided in accordance with the Method of Measurement for Residential Property provided by The Property Council of Australia. This does not represent the area on Title. Purchasers should also refer to building floorplates for any architectural elements which may affect particular apartments as these are not consistent across all levels and apartment types. Purchasers must rely on their own enquiries and the contract of sale.
      </p>
    </div>

  </div>
</template>

<script>
import plazaLogo from '@/assets/logo2.svg';

export default {
  components: {
    plazaLogo
  },
  data() {
    return {
      transitionName: '',
    }
  },
  watch: {
    '$route' (to,from) {
      this.transitionName = to.meta.order > from.meta.order ?  'zoom' : 'prev'
    }
  }
}
</script>

<style lang="scss">

</style>
